/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

export const SET_QUERY_INPUT = 'SET_QUERY_INPUT';
export const FORMAT_QUERY = 'FORMAT_QUERY';
export const TOGGLE_SHOULD_SHOW_ADVANCED_OPTIONS = 'TOGGLE_SHOULD_SHOW_ADVANCED_OPTIONS';
export const SET_INDENTATION = 'SET_INDENTATION';
export const SET_MAX_LINE_LENGTH = 'SET_MAX_LINE_LENGTH';
export const SET_SHOULD_PLACE_DOTS_AFTER_LINE_BREAKS = 'SET_SHOULD_PLACE_DOTS_AFTER_LINE_BREAKS';
